<script>
import date from 'locutus/php/datetime/date'
import defaults from 'lodash/defaults'
import { fetchGroup, createGroup, updateGroup } from '@apis/admin/member'
import LangItem from '@components/admin/lang-input'

export default {
  components: { LangItem },
  props: {
    group_seq: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      params: {},
      info: null,
      loading: false,
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.loading = true
      Promise.all([this.loadGroup()])
        .catch((e) => this.$toasted.error(e.message))
        .finally(() => {
          this.loading = false
        })
    },
    async loadGroup() {
      const { group_info } = await fetchGroup(this.group_seq)
      this.params = defaults(group_info, {
        title: '',
        name: '',
        seq: null,
        regdate: null,
      })
      this.info = group_info
    },
    handleSubmit() {
      const createOrUpdate = this.params.seq ? updateGroup : createGroup
      const confirm_message = this.params.seq
        ? this.$t('admin.msg_save')
        : this.$t('admin.msg_enroll')
      const success_message = this.params.seq
        ? this.$t('member_group_info.msg_modified')
        : this.$t('member_group_info.msg_registered')

      this.loading = true
      this.$confirm(confirm_message, this.$t('admin.modal_confirm'))
        .then(() => createOrUpdate(this.params))
        .then(({ seq }) => this.$emit('submit', seq))
        .then(() => this.$toasted.success(success_message))
        .catch((e) => (e ? this.$toasted.error(e.message) : null))
        .finally(() => {
          this.loading = false
        })
    },
    date,
  },
}
</script>

<template>
  <form
    v-loading="loading"
    action="./"
    method="get"
    @submit.prevent="handleSubmit"
  >
    <table cellspacing="0" cellpadding="0" :class="$style.rowTable">
      <colgroup>
        <col width="20%" />
        <col width="30%" />
        <col width="20%" />
        <col width="30%" />
      </colgroup>
      <tbody>
        <tr>
          <th scope="row"
            ><div>{{ $t('member_group_info.member_group') }}</div></th
          >
          <td><LangItem v-if="!loading" v-model="params.title"></LangItem></td>
          <th scope="row"
            ><div>{{ $t('member_group_info.member_group_name') }}</div></th
          >
          <td>
            <template v-if="params.seq">{{ params.name }}</template>
            <input
              v-else
              v-model="params.name"
              type="text"
              :class="[$style.inputTypeText]"
          /></td>
        </tr>
        <tr>
          <th scope="row"
            ><div>{{ $t('member_group_info.member_output_order') }}</div></th
          >
          <td>
            <input
              v-model="params.list_order"
              type="text"
              :class="[$style.inputTypeText, $style.w40, $style.tRight]"
          /></td>
        </tr>
        <tr>
          <th colspan="4" :class="$style.button">
            <span :class="[$style.button, $style.black]"
              ><input
                type="submit"
                :value="params.seq ? $t('admin.save') : $t('admin.enroll')"
            /></span>
          </th>
        </tr>
      </tbody>
    </table>
  </form>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';
</style>
